import { ConfirmationService } from 'primeng/api';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfirmacaoService {

  constructor(
    private confirmationService: ConfirmationService
  ) { }

  confirmarExclusao(fnAccept: any, fnReject?: any, title?: string, mensagem?: string) {
    this.confirmar( title ? title : 'Confirmação de inativação',
                   mensagem ? mensagem : 'Tem certeza que deseja inativar?',
                   'fa fa-trash',
                   fnAccept,
                   fnReject );
  }

  confirmarAtualizacao(fnAccept: any, fnReject?: any) {
    this.confirmar('Confirmação de atualização',
                   'Tem certeza que deseja salvar?',
                   'fa fa-save',
                   fnAccept,
                   fnReject );
  }

  confirmar(titulo: string, mensagem: string, fa_icon: string, fnAccept: any, fnReject?: any) {
    this.confirmationService.confirm({
        header: ( titulo ? titulo : 'Confirmação de operação' )
        , message: ( mensagem ? mensagem : 'Tem certeza que deseja realizar esta operação?' )
        , icon: fa_icon
        , accept: () => {
            if (fnAccept) { fnAccept(); }
        }
        , reject: () => {
            if (fnReject) { fnReject(); }
        }
    });
  }

  confirmarTextoSimples(titulo: string, fnAccept: any, fnReject?: any) {
    return this.confirmar(titulo, null, null, fnAccept, fnReject);
  }

  confirmarSimples(fnAccept: any, fnReject?: any) {
    return this.confirmar(null, null, null, fnAccept, fnReject);
  }

}
